import axios from 'axios';
import { getAuth } from 'firebase/auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const auth = getAuth();

// Function to get the current user's ID token
const getIdToken = async () => {
    if (auth.currentUser) {
        return await auth.currentUser.getIdToken(true);
    }
    return null;
};

// Generate a blog post using the DeepSeek API
export const generateBlogPost = async (topic) => {
    const idToken = await getIdToken();
    const response = await axios.post(`${API_URL}/api/blog/generate`, { topic }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        }
    });
    return response.data;
};

// Save a new blog post
export const saveBlogPost = async (postData) => {
    const idToken = await getIdToken();
    const response = await axios.post(`${API_URL}/api/blog`, postData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        }
    });
    return response.data;
};

// Get all blog posts with pagination and filtering
export const getAllBlogPosts = async (page = 1, limit = 10, status = null) => {
    const idToken = await getIdToken();
    let url = `${API_URL}/api/blog?page=${page}&limit=${limit}`;
    if (status) {
        url += `&status=${status}`;
    }
    const response = await axios.get(url, {
        headers: {
            'Authorization': `Bearer ${idToken}`
        }
    });
    return response.data;
};

// Get a specific blog post by ID
export const getBlogPostById = async (id) => {
    const idToken = await getIdToken();
    const response = await axios.get(`${API_URL}/api/blog/${id}`, {
        headers: {
            'Authorization': `Bearer ${idToken}`
        }
    });
    return response.data;
};

// Update an existing blog post
export const updateBlogPost = async (id, postData) => {
    const idToken = await getIdToken();
    const response = await axios.put(`${API_URL}/api/blog/${id}`, postData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        }
    });
    return response.data;
};

// Delete a blog post
export const deleteBlogPost = async (id) => {
    const idToken = await getIdToken();
    const response = await axios.delete(`${API_URL}/api/blog/${id}`, {
        headers: {
            'Authorization': `Bearer ${idToken}`
        }
    });
    return response.data;
};